import { getMyAvailabilityConstants } from 'src/redux/actions/constant';

const { GET_MY_AVAILABILITY_SUCCESS, GET_MY_AVAILABILITY_FAILURE, GET_MY_AVAILABILITY_LOADING } =
  getMyAvailabilityConstants;

const intialState: object = {
  response: null,
  isGetAvailability: false,
  data: [],
  loading: false,
};

export const getMyAvailabilityReducer = (state = intialState, action: any) => {
  switch (action.type) {
    case GET_MY_AVAILABILITY_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        isGetAvailability: true,
        data: action.payload.data,
        loading: false,
      };
    }
    case GET_MY_AVAILABILITY_FAILURE: {
      return {
        ...state,
        response: action.payload,
        isGetAvailability: false,
        loading: false,
      };
    }

    case GET_MY_AVAILABILITY_LOADING:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
};
